module.exports = __webpack_public_path__ + "media/img/scholarship_types/Academic Scholarships-12dcfadb39424a535a20e7c47a8af852.svg";